module.exports = __webpack_public_path__ + "static/Truck28-fc26d162e80203adf526710a49ea03a5.png";